module.exports = __webpack_public_path__ + "assets/img/block-c521f7ea.png";